var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16369 2.66455C3.33587 2.66455 2.66479 3.33563 2.66479 4.16345V19.1524C2.66479 19.9802 3.33588 20.6513 4.16369 20.6513H19.1527C19.9805 20.6513 20.6516 19.9802 20.6516 19.1524V4.16345C20.6516 3.33563 19.9805 2.66455 19.1527 2.66455H4.16369ZM7.11742 8.57201C7.92089 8.57201 8.57224 7.92067 8.57224 7.11719C8.57224 6.31371 7.92089 5.66237 7.11742 5.66237C6.31394 5.66237 5.6626 6.31371 5.6626 7.11719C5.6626 7.92067 6.31394 8.57201 7.11742 8.57201ZM9.90461 9.64717H12.3157V10.7517C12.3157 10.7517 12.97 9.44313 14.7502 9.44313C16.3383 9.44313 17.6538 10.2254 17.6538 12.61V17.6382H15.1552V13.2193C15.1552 11.8126 14.4042 11.6579 13.832 11.6579C12.6443 11.6579 12.441 12.6823 12.441 13.4027V17.6382H9.90461V9.64717ZM8.38563 9.64717H5.84922V17.6382H8.38563V9.64717Z",
    fill: "#6B7280"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.1266a2d8.svg";
export { ForwardRef as ReactComponent };